import { TranslateService } from '@ngx-translate/core';

import { IFormFieldPreset } from './form-field-presets';
import { WorkflowFormFieldType } from './form-field-types';

const FIELD_TYPE_LABEL_KEYS: Record<string, string> = {
	text: 'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELD_TYPE_TEXT',
	textarea: 'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELD_TYPE_TEXTAREA',
	select: 'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELD_TYPE_SELECT',
	checkbox: 'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELD_TYPE_CHECKBOX',
	radio: 'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELD_TYPE_RADIO',
	file: 'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELD_TYPE_FILE',
};

const PRESET_TYPE_LABEL_KEYS: Record<WorkflowFormFieldType, string> = {
	text: 'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELD_TYPE_LABEL_SHORT_TEXT',
	textarea: 'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELD_TYPE_TEXTAREA',
	select: 'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELD_TYPE_SELECT',
	checkbox: 'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELD_TYPE_CHECKBOX',
	radio: 'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELD_TYPE_RADIO',
	file: 'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELD_TYPE_FILE',
};

export function resolveFieldTypeLabel(trans: TranslateService, type: string): string {
	return trans.instant(FIELD_TYPE_LABEL_KEYS[type] ?? FIELD_TYPE_LABEL_KEYS['text']);
}

export function resolvePresetFieldPreviewTypeLabel(
	trans: TranslateService,
	preset: IFormFieldPreset | undefined,
	fieldType: string,
): string {
	if (preset?.previewTypeLabelKey) {
		return trans.instant(preset.previewTypeLabelKey);
	}

	return resolveFieldTypeLabel(trans, fieldType);
}

export function resolveDefaultTypeLabelKey(type: WorkflowFormFieldType): string {
	return PRESET_TYPE_LABEL_KEYS[type];
}
